import React from "react";
import { CircularProgress } from "@mui/material";

const ProgressLoader = ({ verPosition = "center", horPosition = "center", size = 48 }) => {
	return (
		<div
			style={{
				display: "flex",
				alignItems: verPosition,
				justifyContent: horPosition,
				padding: "10px",
			}}
		>
			<CircularProgress size={size} color="error" />
		</div>
	);
};

export default ProgressLoader;
